module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "main-headline"
  }, [_vm._v("YOUR PROJECT. YOUR VISION.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "back-button",
    attrs: {
      "tag": "a",
      "to": _vm.backRoute
    }
  }, [_vm._v("\n        Back to Product Guide\n    ")]), _vm._v(" "), _vm._l((_vm.catalog), function(product, idx) {
    return [(idx > 0) ? _c('hr', {
      staticClass: "product-divider"
    }) : _vm._e(), _vm._v(" "), _c('virtual-brick', {
      attrs: {
        "product": product
      }
    })]
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "subheadline"
  }, [_vm._v("\n        Enter text below to visualize what an inscription will look like on your selected brick material."), _c('br'), _vm._v("\n        Please note that the image below will not be an exact representation of the final product.\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a1e6dbd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/virtual/Showroom.vue
// module id = xJLj
// module chunks = 1